import { isLeapYear } from '@/utils/isLeapYear';

const NUM_DAYS_IN_MONTHS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export function addMinutesToDateTimeString(dateTimeString: string, numMinutes: number) {
  // note: this function doesn't worry about daylight savings - the quotebrain ismarketopen endpoint seems to account for that.
  // ...and if we start to autorefresh an hour early once a year, no big deal. this function isn't designed for accepting
  // a numMinutes argument corresponding to more than 6 hours, so I don't think we have much to worry about when it
  // comes to daylight savings

  // yyyy-mm-dd hhh:mm:ss

  if (numMinutes > 360 || numMinutes < -360) {
    throw new Error(`Unable to add minutes to date-time string: numMinutes argument is invalid: ${typeof numMinutes} ${numMinutes}.`);
  }

  const dateArray = dateTimeString.split(/\s/).filter(dateTimeStringPart => !!dateTimeStringPart);
  const remainingDateInfo = dateArray.slice(2).join(' ');
  const dateParts = dateArray[0].split('-');
  let year = Number(dateParts[0]);
  let month = Number(dateParts[1]);
  let day = Number(dateParts[2]);
  const timeParts = dateArray[1].split(':');
  let hours = Number(timeParts[0]);
  let minutes = Number(timeParts[1]);
  const seconds = Number(timeParts[2]);

  minutes += numMinutes;

  if (minutes >= 0 && minutes < 60) {
    return `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day} ${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds} ${remainingDateInfo}`;
  }

  if (minutes >= 60) {
    hours += Math.floor(minutes / 60);
    minutes = minutes % 60;
  } else {
    hours -= Math.ceil(Math.abs(minutes) / 60);
    minutes = 60 - (Math.abs(minutes) % 60);

    if (minutes === 60) {
      minutes = 0;
    }
  }

  if (hours >= 0 && hours < 24) {
    return `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day} ${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds} ${remainingDateInfo}`;
  }

  if (hours >= 24) {
    day++;
    hours = hours % 24;
  } else {
    day--;
    hours = 24 + hours;
  }

  const numDaysInMonths = [ ...NUM_DAYS_IN_MONTHS ];

  if (isLeapYear(year)) {
    numDaysInMonths[1] = 29;
  }

  const numDaysInMonth = numDaysInMonths[month - 1];

  if (day >= 1 && day <= numDaysInMonth) {
    return `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day} ${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds} ${remainingDateInfo}`;
  }

  if (day > numDaysInMonth) {
    day = 1;
    month++;
  } else {
    month--;
    day = numDaysInMonths[month - 1];
  }

  if (month >= 1 && month <= 12) {
    return `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day} ${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds} ${remainingDateInfo}`;
  }

  if (month > 12) {
    day = 1;
    month = 1;
    year++;
  } else {
    day = 31;
    month = 12
    year--;
  }

  return `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day} ${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds} ${remainingDateInfo}`;
}
